<template>
    <div class="header">
        <div style="margin-right:50pxmargin-bottom: 5px;">
            <el-input
            placeholder="按照用户昵称搜索"
            v-model="input"
            clearable
            @keyup.native.enter="SearchUser">
            </el-input>
        </div>
        <el-table
        v-loading="loading"
        :data="list"
        border
        style="width: 1170px; margin: 0 auto;"
        min-height="200"
        max-height="500">
            <el-table-column
                prop="name"
                label="用户昵称"
                width="234">
            </el-table-column>
            <el-table-column
                prop="username"
                label="账号"
                width="234">
            </el-table-column>
            <el-table-column
                prop="rating"
                label="rating"
                width="234">
            </el-table-column>
            <el-table-column
                prop="userrank"
                label="总排名"
                width="234">
            </el-table-column>
            <el-table-column
                fixed="right"
                label="操作"
                width="233">
                <template slot-scope="scope">
                <el-button @click="DeleteUser(scope.row)" type="text" size="big">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
  </div>
</template>

<script>
    import $ from 'jquery'
    import Url from '@/constant/Url';
    export default {
        data() {
            return {
                list:[],
                input: '',
                loading: true,
            }
        },
        created() {
            this.ReadUser()
        },
        methods: {
            ReadUser() {
                const vue = this
                const store = this.$store
                $.ajax({
                    url: Url.rUserUrl,
                    type:"post",
                    success(resp) {
                        if (resp.error_message === 'success') {
                            vue.list = JSON.parse(resp.list)
                            vue.loading = false
                        }
                    }
                })
            },
            DeleteUser(item) {
                this.loading = true
                const vue = this
                const store = this.$store
                console.log("item = ", item)
                $.ajax({
                    url: Url.dUserUrl,
                    type:"post",
                    data: {
                        id: item.id,
                    },
                    headers: {
                        Authorization: "Bearer " + store.state.me.token
                    },
                    success(resp) {
                        if (resp.error_message === "success") {
                            vue.ReadUser()
                            vue.loading = false
                        }
                    }
                })
            },
            SearchUser() {
                this.loading = true
                const vue = this
                const store = this.$store
                $.ajax({
                    url: Url.SearchUserUrl,
                    type:"post",
                    data: {
                        name: vue.input,
                    },
                    headers: {
                        Authorization: "Bearer " + store.state.me.token
                    },
                    success(resp) {
                        if (resp.error_message === "success") {
                            console.log(resp)
                            vue.list = JSON.parse(resp.list)
                            vue.loading = false
                        } else {
                            vue.loading = false
                        }
                    }
                })
            }
        },
        
    }
</script>

<style scoped>
.header {
    border: 1px solid lightgrey;
}
</style>